<template>
  <div :class="classList">
    <p-row nowrap>
      <p-col :xs7="!innerCompact" :xs12="innerCompact">
        <p-date-day-picker
          :value="value"
          v-bind="$props"
          :visible-year="visibleYear"
          :visible-month="visibleMonth"
          :no-year-steppers="!innerCompact"
          @input="$emit('input', $event)"
          @visible-month-change="onVisibleMonthChange"
          @visible-year-change="onVisibleYearChange"
        >
        </p-date-day-picker>
      </p-col>
      <p-divider v-if="!innerCompact" vertical></p-divider>
      <p-col v-if="!innerCompact" xs5>
        <p-date-month-picker
          :value="visibleYear + '-' + visibleMonth + '-1'"
          :min="min"
          :max="max"
          @month-selected="visibleMonth = $event"
          @visible-year-change="onVisibleYearChange"
        ></p-date-month-picker>
      </p-col>
    </p-row>
  </div>
</template>

<script lang="ts">
  import { Dayjs } from 'dayjs';
  import Vue from 'vue';
  import { MediaType } from '../../plugins/media/media';

  export default Vue.extend({
    props: {
      value: { type: String, default: undefined },
      dayStartOfWeek: { type: Number, default: 1 },
      min: { type: String, default: undefined },
      max: { type: String, default: undefined },
      disabledDates: { type: Array, default: () => ([]) },
      compact: { type: Boolean, default: false },
    },
    data: () => ({
      focusedDay: Vue.$date.now().day() as number,
      visibleMonth: Vue.$date.now().month() + 1 as number,
      visibleYear: Vue.$date.now().year() as number,
      selectedDate: undefined as Dayjs | undefined,
      dayNames: [] as string[],
      innerCompact: false,
    }),
    computed: {
      classList(): {} {
        return {
          'p-date-picker': true,
          compact: this.innerCompact,
        };
      },
      selectedDateMonth(): number | undefined {
        if (!this.selectedDate) {
          return undefined;
        }
        return this.selectedDate.month() + 1;
      },
      selectedDateDay(): number | undefined {
        return this.selectedDate?.date();
      },
      selectedDateYear(): number | undefined {
        return this.selectedDate?.year();
      },
      displayMonth(): string {
        return this.$date(`${this.visibleYear}-${this.visibleMonth}-${this.focusedDay}`).format('MMMM');
      },
    },
    watch: {
      compact: {
        immediate: true,
        handler() {
          this.innerCompact = this.compact;
        },
      },
      value: {
        immediate: true,
        handler() {
          if (this.value) {
            const dateObj = this.$date(this.value);
            this.selectedDate = dateObj;
            this.focusedDay = dateObj.date();
            this.visibleMonth = dateObj.month() + 1;
            this.visibleYear = dateObj.year();
          }
        },
      },
    },
    beforeMount() {
      this.$media.addResizeListeners(this.onWindowResize);
    },
    beforeDestroy() {
      this.$media.removeResizeListeners(this.onWindowResize);
    },
    methods: {
      onVisibleMonthChange(month: number) {
        this.visibleMonth = month;
      },
      onVisibleYearChange(year: number) {
        this.visibleYear = year;
      },
      onWindowResize(mediaType: MediaType) {
        const isMobileOrTablet = mediaType === 'mobile' || mediaType === 'tablet';
        this.innerCompact = isMobileOrTablet || this.compact;
      },
      addYear(amount: number) {
        const dateObj = this.$date(`${this.visibleYear}-${this.visibleMonth}-${this.focusedDay}`);
        const newDateObj = dateObj.add(amount, 'year');
        this.visibleMonth = newDateObj.month() + 1;
        this.visibleYear = newDateObj.year();
      },
    },
  });
</script>
